import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import DictsInfo from '../../components/dicts_info.jsx'

function refreshPage(){
    setTimeout(()=>{
      window.location.reload(false);
    }, 500);
   
  }


export default class CaraMembuatCustomListPadaMsOfficeExcel2010 extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Cara Membuat Custom List Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Cara Membuat Custom List Pada Microsoft Office Excel 2010</h1>

                <p>Custom list diperlukan untuk mempersingkat pembuatan daftar atau list yang sering kita gunakan. Misalnya daftar hari dari senin sampai minggu, daftar waktu sholat dari Shubuh sampai Isya dan sebagainya. </p>

                <p>Kita tinggal menginput nama awal dari custom list tersebut pada sel pertama, kemudian setelah kita drag ke arah yang di inginkan, daftar akan secara otomatis terbuat mengisi sel sel yang ada.</p>

                <p>Tidak perlu panjang lebar berikut cara membuat daftar untuk digunakan secara otomatis mengisi sel hanya dengan mengisi sel awal.</p>

                <div className= "w3-container" > 
                    <ol> 
                        <li>Klik <b>File</b></li> 
                        <li>Lalu klik <b>Options</b></li> 
                        <li>Setelah jendela <b>Options</b> terbuka, pada bagian kiri jendela pilih <b>Advanced</b></li> 
                        <li>Setelah klik <b>Advanced</b>, arahkan mouse ke bagian kanan jebdela. Lalu scroll ke arah bawah sampai ke bagian <b>General</b></li> 
                        <li>Pada bagian <b>General</b>, cari tombol <b>Edit Custom Lists...</b>, lalu klik pada tombol <b>Edit Custom Lists...</b> tersebut</li> 
                        <li>Seelah klik pada tombol <b>Edit Custom Lists...</b> tersebut, jendela baru akan terbuka. Yaitu jendela untuk mengedit custom list.</li> 
                        <li>Klik <b>NEW LIST</b> pada kotak <b>Custom Lists</b> dan lalu masukkan daftar yang diinginkan pada kotak <b>List Entries</b>.
                        <br/>
                        Contoh:
                        <div className="w3-container">
                            Senin lalu Enter
                            <br/>
                            Selasa lalu Enter
                            <br/>
                            Dan seterusnya..
                        </div>
                        </li> 

                        <li>Apabila list atau daftar yang dimaksud sudah selesai di masukkan atu dibuat, lalu klik tombol <b>Add</b></li> 
                        <li>Setelah itu klik tombol <b>OK</b> pada jendela <b>Custom List</b></li> 
                        <li>Dan klik tombol <b>OK</b> lagi pada bagian jendela <b>Options</b></li> 
                    </ol> 
                </div>

                <br/>

                
                <p>Begitulah caranya.</p>
                <p>Cara menggunakan nya cukup mudah seperti  <Link to="/microsoft-office-excel-2010/cara-membuat-nomor-urut-pada-ms-office-excel-2010" className="nav-link" onClick={refreshPage}>cara membuat nomor urut</Link>
                         , cukup drag ke arah mana daftar akan dibuat.</p>
                

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
